export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/animated.50c7b48.svg";